(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ "9IA0":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGNsaXAtcGF0aDogdXJsKCNjbGlwLWFycm93X3NvbGlkX2JsYWNrKTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtYXJyb3dfc29saWRfYmxhY2siPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSJhcnJvd19zb2xpZF9ibGFjayIgY2xhc3M9ImNscy0xIj4KICAgIDxwYXRoIGlkPSJQYXRoXzE1MzUiIGRhdGEtbmFtZT0iUGF0aCAxNTM1IiBjbGFzcz0iY2xzLTIiIGQ9Ik0zMCwxMS40SDEwLjA1bDcuNzI1LTcuNzI1TDE0LjAyNSwwLDMuNjc1LDEwLjM1LDAsMTQuMDI1SDBMMi45MjUsMTYuOTVsMTEuMSwxMS4xLDMuNzUtMy42NzVMMTAuMDUsMTYuNjVIMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzUpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIxMjYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIxMjYiIGNsYXNzPSJjbHMtMyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIi8+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "CR6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1OyB");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("vuIU");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("JX7q");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Ji7U");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("md7G");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("foSv");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("vOnD");
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("NVT0");







var __jsx = react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }





var arrowBlackIcon = __webpack_require__("P6o1");

var arrowWhiteIcon = __webpack_require__("9IA0");

var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
  displayName: "SliderGallery__Wrapper",
  componentId: "sc-1lpnm5n-0"
})(["position:relative;"]);
var SliderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
  displayName: "SliderGallery__SliderWrapper",
  componentId: "sc-1lpnm5n-1"
})(["display:flex;flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;scrollbar-width:none;padding-bottom:", "px;&::-webkit-scrollbar{display:none;}"], function (props) {
  return props.theme.baseline;
});
var SliderChildWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
  displayName: "SliderGallery__SliderChildWrapper",
  componentId: "sc-1lpnm5n-2"
})(["display:flex;flex-shrink:0;justify-content:center;width:", "px;"], function (props) {
  return props.width / props.splits[props.breakpointToSplitIndex()];
});
var Arrow = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].img.withConfig({
  displayName: "SliderGallery__Arrow",
  componentId: "sc-1lpnm5n-3"
})(["display:", ";cursor:pointer;position:absolute;top:calc(50% - 15px);width:30px;height:auto;transition:0.2s ease-in-out;", ";", ";z-index:2;@media ", "{display:block;width:36px;top:calc(50% - 18px);}@media ", "{width:48px;top:calc(50% - 24px);}"], function (props) {
  return props.navigation[props.breakpointToSplitIndex()] ? 'block' : 'none';
}, function (props) {
  return props.direction === 'back' && 'transform: rotateY(180deg)';
}, function (props) {
  return props.direction === 'forward' ? "left: ".concat(props.theme.baseline, "px") : "right: ".concat(props.theme.baseline, "px");
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});

var SliderGallery = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(SliderGallery, _Component);

  var _super = _createSuper(SliderGallery);

  /**
   * SliderGallery
   *
   * Going from "mobile" to "desktopLarge", define..
   *
   * @param {Number[]} props.splits=[] How many children should be displayed for each breakpoint.
   * @param {Number[]} props.offsets=[] The default scroll-offset for each breakpoint.
   * @param {Boolean[]} props.navigation=[] Wether navigation should be visible for each breakpoint.
   */
  function SliderGallery(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(this, SliderGallery);

    _this = _super.call(this, props);

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "updateDimensions", function () {
      _this.setState({
        width: _this.getElementWidth()
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "breakpointToSplitIndex", function () {
      var index = 0;

      if (true) {
        if (window.matchMedia(styles_theme__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].breakpoints.desktopLarge).matches) {
          index = 3;
        } else if (window.matchMedia(styles_theme__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].breakpoints.desktop).matches) {
          index = 2;
        } else if (window.matchMedia(styles_theme__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"].breakpoints.tablet).matches) {
          index = 1;
        }
      }

      return index;
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this), "navigate", function (direction) {
      var _this$element$current = _this.element.current,
          scrollWidth = _this$element$current.scrollWidth,
          scrollLeft = _this$element$current.scrollLeft;
      var splits = _this.props.splits;

      var step = _this.getElementWidth() / splits[_this.breakpointToSplitIndex()];

      var next = direction === 'back' ? scrollLeft + step : scrollLeft - step;
      next = next < 0 ? 0 : next;
      next = next > scrollWidth ? scrollWidth : next;
      _this.element.current.scrollLeft = next;
    });

    _this.element = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createRef();
    _this.state = {
      width: 0
    };
    _this.updateDimensions = _this.updateDimensions.bind(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(_this));
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(SliderGallery, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.updateDimensions);
      setTimeout(function () {
        _this2.updateDimensions();

        var offsets = _this2.props.offsets;
        _this2.element.current.scrollLeft = offsets[_this2.breakpointToSplitIndex()];
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "getElementWidth",
    value: function getElementWidth() {
      if (this.element.current) {
        return this.element.current.getBoundingClientRect().width;
      }

      return 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          splits = _this$props.splits,
          navigation = _this$props.navigation,
          altTheme = _this$props.altTheme;
      var width = this.state.width;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(Wrapper, null, children.length > 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(Arrow, {
        altTheme: altTheme,
        breakpointToSplitIndex: this.breakpointToSplitIndex,
        src: altTheme ? arrowWhiteIcon.url : arrowBlackIcon.url,
        onClick: function onClick() {
          return _this3.navigate('back');
        },
        navigation: navigation,
        direction: "back"
      }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(SliderWrapper, {
        ref: this.element,
        splits: splits,
        width: width
      }, react__WEBPACK_IMPORTED_MODULE_7___default.a.Children.map(children, function (child) {
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(SliderChildWrapper, {
          breakpointToSplitIndex: _this3.breakpointToSplitIndex,
          splits: splits,
          width: width
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.cloneElement(child));
      })), children.length > 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_7___default.a.createElement(Arrow, {
        altTheme: altTheme,
        breakpointToSplitIndex: this.breakpointToSplitIndex,
        src: altTheme ? arrowWhiteIcon.url : arrowBlackIcon.url,
        onClick: function onClick() {
          return _this3.navigate('forward');
        },
        navigation: navigation,
        direction: "forward"
      }));
    }
  }]);

  return SliderGallery;
}(react__WEBPACK_IMPORTED_MODULE_7__["Component"]);

SliderGallery.defaultProps = {
  splits: [1, 3, 3, 4],
  navigation: [false, true, true, true],
  offsets: [0, 0, 0, 0],
  altTheme: false
};
/* harmony default export */ __webpack_exports__["a"] = (SliderGallery);

/***/ }),

/***/ "P6o1":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMzAgMzAiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGNsaXAtcGF0aDogdXJsKCNjbGlwLWFycm93X3NvbGlkX2JsYWNrKTsKICAgICAgfQoKICAgICAgLmNscy0yIHsKICAgICAgICBmaWxsOiAjMDAwOwogICAgICB9CgogICAgICAuY2xzLTMgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtYXJyb3dfc29saWRfYmxhY2siPgogICAgICA8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgogIDxnIGlkPSJhcnJvd19zb2xpZF9ibGFjayIgY2xhc3M9ImNscy0xIj4KICAgIDxwYXRoIGlkPSJQYXRoXzE1MzUiIGRhdGEtbmFtZT0iUGF0aCAxNTM1IiBjbGFzcz0iY2xzLTIiIGQ9Ik0zMCwxMS40SDEwLjA1bDcuNzI1LTcuNzI1TDE0LjAyNSwwLDMuNjc1LDEwLjM1LDAsMTQuMDI1SDBMMi45MjUsMTYuOTVsMTEuMSwxMS4xLDMuNzUtMy42NzVMMTAuMDUsMTYuNjVIMzBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNzUpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIxMjYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDIxMjYiIGNsYXNzPSJjbHMtMyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIi8+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "qcE3":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "v04A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/shared/SliderGallery/index.js
var SliderGallery = __webpack_require__("CR6s");

// EXTERNAL MODULE: ./components/shared/ReviewComponents/index.js + 5 modules
var ReviewComponents = __webpack_require__("wjrY");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/config/userReviews.js
var avatarTestImg = __webpack_require__("qcE3");

var trustpilotLogo = __webpack_require__("2932");

var facebookLogo = __webpack_require__("XE64");

var userReviews = {
  "default": [{
    name: 'FG',
    platformImage: trustpilotLogo,
    text: "I have never seen such an friedly and opend minded Company. There is always time and space for ideas and Wishes and also a very lovely rellationsip too there Customers. I can ask whatever i want and also get help in any way. Even if you ask dumb questions haha:)\n      <br/><br/>\n      Stay as you are guys and #getlouder"
  }, {
    name: 'Marco Ramirez',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Best purchase ever I use it on a daily basis playing music while getting ready for work and finally got to see its full potential on an Easter picnic with all my family and friends I received a lot of compliments by people at the park not to mention it drowned all of the music coming from other picnic, they never stood a chance lol greatly guarantee this speaker it’s worth paying more to only buy once and this speaker sure feels like it can stand time.'
  }, {
    name: 'Jan Siekierski',
    platformImage: facebookLogo,
    text: "This speaker is just unbelievable. It's exactly what you expect and much more. Seems indestructible, battery can go for days, sound is beautiful and incredibly powerful, while being clear.\n      It really brings people together. I didn't realize that a speaker can change so much.\n      "
  }, {
    name: 'Christopher',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Very impressed with the Soundboks 2. Saw many reviews on YouTube and sound demos but that doesn’t do justice for what this speaker produces. Holy cow! Awesome job by Soundboks!'
  }, {
    name: 'Inês Marques',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'No lies, this is the loudest speaker in the world - simply outstanding performance and unbelievable sound quality'
  }],
  // TODO: Change reviews
  de: [{
    name: 'Nils',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Bester, robuster, lautester, den Mädels die Klamotten vom Leib reißender Bluetooth Speaker ! Holt ihn oder geht hört weiterhin leise Musik mit schlechten Sound. Klares must have!'
  }, {
    name: 'Jens Hornschuh',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Kaufen, ab an Strand und Paaarty satt! Einfach nur geil Hammerteil!'
  }, {
    name: 'Johannes Lui',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'ist jeden Cent wert. Nicht mehr wegzudenken😛 Akku ist der Wahnsinn. Sound ist brutal.'
  }, {
    name: 'Markus Rink',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Meine Boks ist angekommen und der Sound ist der Hammer. Zudem ist dieses Gerät einfach nur laut ! Der Kundenservice ist zudem einfach nur top. Vielen Dank Soundboks-Team!'
  }, {
    name: 'Aaron Caffrey',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Der Klang zum Handling zum Gewicht ist ein Geiler Faktor bei der soundboks Ich nehme sie auf mein Moped mit auf die Arbeit und ist einfach der hammer:))'
  }, {
    name: 'Oliver Dokter',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Kenne die Soundboks von freunden habe mir nun selbst eine zugelegt, ist einfach die beste musikbox. Bin gespannr auf die Versand zeit direkt über die Soundboks seite'
  }, {
    name: 'Markus',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Schneller Versand: ich war beeindruckt wie schnell der Artikel aus den USA bei mir war. Der Service ist hervorragend und das Soundboks Team ständig auf der Suche nach Verbesserung. Ich würde hier immer wieder kaufen und kann es nur weiterempfehlen. An das Soundboks Team: macht weiter so! Einfach klasse!'
  }]
};
/* harmony default export */ var config_userReviews = (userReviews);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Reviews/UserReviews.js
var __jsx = react_default.a.createElement;






var ContentTablet = styled_components_browser_esm["default"].div.withConfig({
  displayName: "UserReviews__ContentTablet",
  componentId: "sc-116kovm-0"
})(["display:none;justify-content:space-between;> div > div{margin-bottom:20px;}@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:20px;}@media ", "{grid-template-columns:1fr 1fr 1fr;}@media ", "{> div:last-child{display:none;}}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.onlyTablet;
});
var ContentMobile = styled_components_browser_esm["default"].div.withConfig({
  displayName: "UserReviews__ContentMobile",
  componentId: "sc-116kovm-1"
})(["@media ", "{display:none;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
var StyledReview = Object(styled_components_browser_esm["default"])(ReviewComponents["c" /* Review */]).withConfig({
  displayName: "UserReviews__StyledReview",
  componentId: "sc-116kovm-2"
})(["margin-right:", "px;@media ", "{margin-left:", "px;margin-right:", "px;}@media ", "{margin-left:", "px;margin-right:", "px;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 1;
}, function (props) {
  return props.theme.baseline * 1;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.baseline * 2;
});

var UserReviews_getReviews = function getReviews(regionId) {
  var reviews = regionId === 'de' ? config_userReviews.de : config_userReviews["default"];
  var reviewComponents = [];
  reviews.map(function (review) {
    return reviewComponents.push( /*#__PURE__*/react_default.a.createElement(StyledReview, {
      name: review.name,
      platformImage: review.platformImage,
      key: review.name
    }, review.text));
  });
  return reviewComponents;
};

var UserReviews_UserReviews = function UserReviews() {
  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  var reviews = UserReviews_getReviews(regionId);
  return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(ContentTablet, null, /*#__PURE__*/react_default.a.createElement("div", null, reviews.slice(0, 2)), /*#__PURE__*/react_default.a.createElement("div", null, reviews.slice(2, 4)), /*#__PURE__*/react_default.a.createElement("div", null, reviews.slice(4, 6))), /*#__PURE__*/react_default.a.createElement(ContentMobile, null, /*#__PURE__*/react_default.a.createElement(SliderGallery["a" /* default */], null, reviews)));
};

/* harmony default export */ var Reviews_UserReviews = __webpack_exports__["a"] = (UserReviews_UserReviews);

/***/ })

}]);